module.exports = __webpack_public_path__ + "img/lg_ring_g_0_null_1.ee420e65.png";